export const API_BASE_URL_ENV = () => {
	return "https://back.afkartest.online/api";
};
